import useSlugExtractor from "@hooks/useSlugExtractor"

import { AccessCheck } from "@particles"

import { TopBar } from "@organisms"
import ViewTypesProvider from "@organisms/ObjectsView/ViewTypesProvider/ViewTypesProvider"

import { AppFrame } from "@templates"

import { CLIENTS_ROUTES } from "@routes/clients"

import { objectMap } from "@constants/objectMap"
import { PERMISSION_LEVEL } from "@constants/permissionLevel"
import { CLIENTS_LIST_CONTROLS_VIEW } from "@constants/storage"

import ClientTableView from "./views/ClientTableView/ClientTableView"

export default function ClientList() {
    const [createRoute] = useSlugExtractor([CLIENTS_ROUTES.CREATE])

    return (
        <AppFrame.Root pageId="ClientList">
            <ViewTypesProvider viewTypeKey={CLIENTS_LIST_CONTROLS_VIEW} defaultViewType="table">
                {() => (
                    <>
                        <TopBar.Root>
                            <TopBar.Header>
                                <TopBar.TopBarHeaderStart>
                                    <TopBar.PageTitle
                                        label={objectMap.client.labelPlural}
                                        icon={objectMap.client.iconActive}
                                    />
                                </TopBar.TopBarHeaderStart>
                                <TopBar.TopBarHeaderEnd>
                                    <TopBar.PagePresence />
                                    <AccessCheck
                                        permissions={{
                                            clients_list_permission: PERMISSION_LEVEL.RESTRICTED,
                                        }}
                                    >
                                        <AccessCheck
                                            permissions={{
                                                clients_view_permission: PERMISSION_LEVEL.FULL,
                                            }}
                                        >
                                            <TopBar.SearchButton scope="Clients" />
                                        </AccessCheck>
                                    </AccessCheck>
                                    <TopBar.ViewSelector viewTypes={["table"]} />
                                    <AccessCheck
                                        permissions={{
                                            clients_create_permission: PERMISSION_LEVEL.RESTRICTED,
                                        }}
                                    >
                                        <TopBar.CTAButton destination={createRoute} />
                                    </AccessCheck>
                                </TopBar.TopBarHeaderEnd>
                            </TopBar.Header>
                        </TopBar.Root>
                        <ClientTableView />
                    </>
                )}
            </ViewTypesProvider>
        </AppFrame.Root>
    )
}
